import { createSelector } from '@ngrx/store';
import { RootState } from '../../index';

const depotIdRegex = /[A-Z]{2}\d{2}_|d{3}/; // NL14_001

export const selectOrderDepots = createSelector((state: RootState) => state.orders.filterValues.locations, locations => {
  return locations.filter(location => {
    return location.isDepot || depotIdRegex.test(location.id);
  })
})
